import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
// import { RegionModel } from '../models/region';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: 'root'
})
export class FrequencyProvider {

  frequency = [];
  actionSuccess:boolean = false;

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
    ) {
  }

  getFrequencyList(): void {
    if (this.frequency.length == 0) {
      this.apiService.getHeaders(this.apiConfig.configGetFrequency).subscribe(
        (res: any) => {
          this.frequency = res.body.data;
        }
      );
    }
  }

}
  // let updatedRegions =this.regions.splice(updateIndex, 1);
